import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AsyncController::index
* @see app/Http/Controllers/AsyncController.php:17
* @route 'https://app.pokor.dev/{session}/async'
*/
export const index = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev/{session}/async',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AsyncController::index
* @see app/Http/Controllers/AsyncController.php:17
* @route 'https://app.pokor.dev/{session}/async'
*/
index.url = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { session: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { session: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            session: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        session: typeof args.session === 'object'
        ? args.session.slug
        : args.session,
    }

    return index.definition.url
            .replace('{session}', parsedArgs.session.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AsyncController::index
* @see app/Http/Controllers/AsyncController.php:17
* @route 'https://app.pokor.dev/{session}/async'
*/
index.get = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AsyncController::index
* @see app/Http/Controllers/AsyncController.php:17
* @route 'https://app.pokor.dev/{session}/async'
*/
index.head = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AsyncController::show
* @see app/Http/Controllers/AsyncController.php:22
* @route 'https://app.pokor.dev/{session}/async/{story}'
*/
export const show = (args: { session: string | number | { slug: string | number }, story: string | number | { id: string | number } } | [session: string | number | { slug: string | number }, story: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev/{session}/async/{story}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AsyncController::show
* @see app/Http/Controllers/AsyncController.php:22
* @route 'https://app.pokor.dev/{session}/async/{story}'
*/
show.url = (args: { session: string | number | { slug: string | number }, story: string | number | { id: string | number } } | [session: string | number | { slug: string | number }, story: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            session: args[0],
            story: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        session: typeof args.session === 'object'
        ? args.session.slug
        : args.session,
        story: typeof args.story === 'object'
        ? args.story.id
        : args.story,
    }

    return show.definition.url
            .replace('{session}', parsedArgs.session.toString())
            .replace('{story}', parsedArgs.story.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AsyncController::show
* @see app/Http/Controllers/AsyncController.php:22
* @route 'https://app.pokor.dev/{session}/async/{story}'
*/
show.get = (args: { session: string | number | { slug: string | number }, story: string | number | { id: string | number } } | [session: string | number | { slug: string | number }, story: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AsyncController::show
* @see app/Http/Controllers/AsyncController.php:22
* @route 'https://app.pokor.dev/{session}/async/{story}'
*/
show.head = (args: { session: string | number | { slug: string | number }, story: string | number | { id: string | number } } | [session: string | number | { slug: string | number }, story: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

const async = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
}

export default async